export default {
	tenantId: "asia",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "asia"
	}
}
